





















































import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import AgentTable from "@/components/agent/AgentTable.vue";
import { agentApi } from "@/getinfo-api";
import agentList, { AgentListParams } from "@/getinfo-api/agent";
import { getCurrentCompanyId } from "@/plugins/roles";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { ConditionsListClass } from "@/classes/list/ConditionsListClass";
import { Agent as IAgent } from "@/api-v2/agent/models";
//TODO ADD TRANSLATE

@Component({
  components: { CSingleSelect, AgentTable, CBlock, CPage }
})
export default class AgentList extends Vue {
  isLoading: boolean = false;
  agents: IAgent[] = [];
  count: number = 0;
  conditionsList: ConditionsListClass = new ConditionsListClass();
  conditionId?: string;
  firstName!: string;
  surname!: string;
  offset: number = 0;

  data() {
    return {
      conditionId: undefined,
      firstName: undefined,
      surname: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  async removeAgentHandler(agent: IAgent) {
    try {
      this.isLoading = true;
      const response = await agentApi.Agent.deleteAgent(agent!.id!);
      if (response.status === 204 || response.status === 200) {
        this.agents = this.agents?.filter(el => el.id !== agent.id);
        this.count = this.count - 1;
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  showMore() {
    this.offset += 30;
    this.getAgents(this.offset);
  }

  applyFilterHandler() {
    this.agents = [];
    this.count = 0;
    this.offset = 0;
    this.getAgents();
  }

  clearFilterHandler() {
    this.firstName = "";
    this.surname = "";
    this.conditionId = undefined;
    this.offset = 0;
    this.agents = [];
    this.getAgents();
  }

  async getAgents(offset: number = 0) {
    const params: AgentListParams = {
      ids: undefined,
      firstName: this.firstName?.length ? this.firstName : undefined,
      lastName: this.surname?.length ? this.surname : undefined,
      middleName: undefined,
      conditionsIds: this.conditionId ? [this.conditionId] : undefined,
      createdAtMin: undefined,
      createdAtMax: undefined,
      companyId: this.companyId,
      sort: "updatedAt",
      order: "DESC",
      offset: offset,
      limit: 30
    };

    try {
      this.isLoading = true;
      const { data } = await agentList(params);
      this.agents = [...this.agents, ...data.items];
      this.count = data.count;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getAgents();
  }
}
